import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

/**
 * Renders an installation's UTG version with a tooltip explaining that the stored version is the one
 * chosen when the package was created, and that GA-tracking installs resolve to the current GA build
 * at install time instead.
 */
function UtgVersionWithTooltip({ children, tracksGa = false, placement = "bottom", delayShow = 100, delayHide = 250 }) {
    const version = children

    if (version == null || version === '') {
        return ''
    }

    const message = tracksGa
        ? 'This install tracks GA. The version shown is the one selected when the package was created, but installing with this Verification ID will always deploy the current GA version.'
        : 'The version selected when this package was created. Installing with this Verification ID will always deploy this specific version.'

    const renderTooltip = (props) => (
        <Tooltip {...props}>{message}</Tooltip>
    )

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: delayShow, hide: delayHide }}
            overlay={renderTooltip}
        ><span>{version}</span></OverlayTrigger>
    )
}

export default UtgVersionWithTooltip
